import { configs } from "../configs";

const { serverUrl, fileServer } = configs;

const baseUrl = `${serverUrl}/product`;

export const uploadImageToServer = (file) => {
    const imageData = new FormData();
    imageData.append("image",file);
    return fetch(`${fileServer}/upload_image`,{
        method: "POST",
        body: imageData
    })
}


export const deleteImageFromServer = (uri) => {
    return fetch (`${fileServer}/delete_image`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({uri})
    })
}

//upload new product
export  const uploadNewProduct = (data,token) => {
    return fetch (`${baseUrl}/addproduct`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}

//get some products
export const getProductBatch = (query='') => {
    return fetch (`${baseUrl}/load${query}`, {
        method: "GET",
        mode: "cors"
    })
}

//get all products
export const getAllProducts = () => {
    return fetch (`${baseUrl}/allproducts`,{
        method: "GET",
        mode: 'cors'
    })
}

//update product data
export const updateProductData = (data, id, token) => {
     return fetch (`${baseUrl}/${id}`,{
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(data),
        mode: "cors"
    })
}

/**
 * @param {string} id ObjectId 
 */
export const getProductById = (id) => {
    return fetch (`${baseUrl}/${id}`,{
        method: "GET",
        mode: "cors"
    })
}

export const deleteProductById = (id, token) => {
    return fetch (`${baseUrl}/${id}`,{
        method: "DELETE",
         headers: {
            "Authorization": `Bearer ${token}`
        },
        mode: 'cors'
    })
}

export const processOrder = (orderData) => {
    return fetch (`${baseUrl}/order`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(orderData),
        mode: "cors"
    })
}